/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Cookie_Frame_TitleInputs */

const en_cookie_frame_title = /** @type {(inputs: Cookie_Frame_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accept ${i?.category} consent to view this content.`)
};

const lv_cookie_frame_title = /** @type {(inputs: Cookie_Frame_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lai skatītu šo saturu, atļaujiet sīkdatnes kategorijā “${i?.category}”.`)
};

/**
* | output |
* | --- |
* | "Accept {category} consent to view this content." |
*
* @param {Cookie_Frame_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_frame_title = /** @type {((inputs: Cookie_Frame_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Frame_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_frame_title(inputs)
	return en_cookie_frame_title(inputs)
});